import {useEffect} from 'react';
import {useTranslation} from 'react-i18next';
import Accordion from '../../package/componnent/accordion/Accordion';
import GeneralForm from '../generalForm/GeneralForm';
import PaymentForm from '../paymentForm/PaymentForm';
import MailingForm from '../mailingForm/MailingForm';
import ReportForm from '../reportForm/ReportForm';
import {getEventSettings} from '../../../redux/event/eventActions';
import {getCrowds} from '../../../redux/crowds/crowdsActions';
import {getEventTeam} from '../../../redux/team/teamActions';
import SaleForm from '../saleForm/SaleForm';
import {useSelector} from 'react-redux';
import SettingsPopupWrapper from '../settingsPopupWrapper/SettingsPopupWrapper';
import TicketsMailingForm from '../ticketsMailingForm/TicketsMailingForm';
import ClubForm from '../clubForm/ClubForm';
import AccountPermission from '../../components/accountPermission/AccountPermission';

function SettingsPopup({showClass, close}) {
    const {t} = useTranslation('event');
    const getEventSettingsXHR=useSelector(state=>state.event.getEventSettingsXHR);
    const getEventTeamXHR = useSelector(s => s.team.getEventTeamXHR);
    const getCrowdsXHR=useSelector(state=>state.crowds.getCrowdsXHR);
    const langDesign = useSelector(state => state.event.settings?.langDesign);
    const eventType = useSelector(state => state.event.type);
    const consumerClubs = useSelector(state => state.account.consumerClubs);
    const clubsSettings = useSelector(state => state.event.settings?.clubs);
    
    const isClubsAccordionClosed = !clubsSettings || 
                                   !Object.values(clubsSettings).some(setting => setting === true || setting === 1);

    useEffect(() => {
        if(!getEventSettingsXHR)
            getEventSettings().then();
        if(!getEventTeamXHR)
            getEventTeam().then();
        if(!getCrowdsXHR)
            getCrowds().then();
    }, []);
   
    return (
        <SettingsPopupWrapper showClass={showClass} close={close}>
            <>
                <Accordion title={t('generalSettings')} dataCyTitle='generalSettings'>
                    <GeneralForm langDesign={langDesign}/>
                </Accordion>
                <Accordion title={t('PaymentsAndStanding')}  isClose dataCyTitle='PaymentsAndStanding'>
                    <PaymentForm close={close} />
                </Accordion>
                <AccountPermission permission="whatsApp">
                    <Accordion title={t('ticketsAndMailing')} isClose dataCyTitle='ticketsAndMailing'>
                        <TicketsMailingForm />
                    </Accordion>
                </AccountPermission>
                <Accordion title={t('advertisingMarketing')} isClose dataCyTitle='advertisingMarketing'>
                    <MailingForm />
                </Accordion>
                {['area', 'ticket'].includes(eventType) && consumerClubs.length > 0 && <AccountPermission permission="consumer clubs" >
                    <Accordion title={t('clubs')} isClose={isClubsAccordionClosed} dataCyTitle='clubs'>
                        <ClubForm />
                    </Accordion>
                </AccountPermission>}
                <Accordion title={t('reportsAndUpdates')} isClose dataCyTitle='reportsAndUpdates'>
                    <ReportForm />
                </Accordion>
                <Accordion title={t('sale')} isClose dataCyTitle='sale'>
                    <SaleForm />
                </Accordion>
            </>
        </SettingsPopupWrapper>
    );
}

export default SettingsPopup;
